var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPageBlank(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.75 1.25h5.976c.73 0 1.43.29 1.946.806l4.273 4.278a2.75 2.75 0 01.805 1.944v11.904c0 .71-.21 1.368-.677 1.853-.47.488-1.118.715-1.823.715H6.75c-.705 0-1.353-.227-1.823-.715-.466-.485-.677-1.143-.677-1.853V3.819c0-.71.21-1.369.677-1.853.47-.488 1.118-.716 1.823-.716zm6.746 6.25V3.015L17.979 7.5h-4.483zM6.75 2.75c-.382 0-.609.117-.742.256-.137.142-.258.393-.258.813v16.363c0 .42.12.67.258.812.133.14.36.256.742.256h10.5c.382 0 .609-.117.742-.256.137-.142.258-.393.258-.812L18.246 9h-5.5a.75.75 0 01-.75-.75v-5.5H6.75z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageBlank);
export default __webpack_public_path__ + "static/media/PageBlank.3a9b15a90ed1c4770bd3210aac1180a5.svg";
export { ForwardRef as ReactComponent };